import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import Warning from "../../../assets/img/icons/warning.svg";
import Finish from "../../../assets/img/icons/finish.svg";
import CloseIcon from "../../../assets/img/close.png";
import PropTypes from "prop-types";
import {getMinistryStatusBarRatings,ministryOverfinanced} from "../../../helpers/feedbackHelpers";
import connect from "react-redux/es/connect/connect";
import PopupTitle from '../PopupTitle';

class FeedbackStatusRounds extends Component {
  static propTypes = {
    transitionDelay: PropTypes.string,
    ministry: PropTypes.string,
  };

  static defaultProps = {
    transitionDelay: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      showWarning: false,
      showComponent: false,
    };
    this.warningPopup = this.warningPopup.bind(this);
    this.getPill = this.getPill.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener("mousedown", this.warningPopup);
  }

  warningPopup(content) {
    if (!this.state.showWarning) {
      window.addEventListener("mousedown", this.warningPopup);
      this.setState({
        showWarning: true
      });
    } else {
      window.removeEventListener("mousedown", this.warningPopup);
      this.setState({
        showWarning: false,
      });
    }
  }

  getPill(percentage, currentRound, gameState) {
    const overfinanced = ministryOverfinanced(this.props.ministry, gameState, currentRound);
    const full = (percentage >= 50 || percentage <= -50);

    return (
      <div key={`${currentRound}`} className={`round-pill ${percentage === null ? 'inactive' : ''}`}>
        {percentage !== null ?
          <span
            className={`status-pill ${percentage > 0 ? 'pos' : 'neg'} ${Math.abs(percentage) > 30 ? 'almost-full' : ''} ${Math.abs(percentage) >= 50 || full ? 'full' : ''}`}
            style={{height: 'calc(' + (Math.abs(percentage)) + '% ' + (percentage > 0 ? '+ 1' : '- 1') + 'px)'}}
          /> :
          null
        }
        {percentage !== null && overfinanced ?
          <div className={'disaster-container'}>
            <img alt={'disaster'} onClick={this.warningPopup} src={Warning}/>
          </div>:
          ''}
      </div>
    );
  }

  render() {
    const { gameState, gameStateInput, desktop } = this.props;
    const ratings = getMinistryStatusBarRatings(this.props.ministry, gameState, gameStateInput);
    return (
      <div className={'status-rounds ' + (this.props.transitionDelay)}>
        <div className={'content-container'}>
          <div className="content-container-background"/>
          <PopupTitle title={__('sim_status')} popupId={`${desktop ? 'd' : 'm'}${gameState.difficulty === 'PRO' ? 'h' : 'l'}gvtstatusbalkje`} tag={'h3'}/>
          <div className="pill-container">
            {[...Array(11)].map(()=> <span key={Math.random() * Math.floor(100*100)} className={'line'}/>)}
            {ratings.map((r, c) => this.getPill(r, c, gameState))}
          </div>

          <div className={'round-names'}>
            <p className={gameState.currentRound >= 1 ? '' : 'inactive'}>{__('sim_ronde')} 1</p>
            <p className={gameState.currentRound >= 2 ? '' : 'inactive'}>{__('sim_ronde')} 2</p>
            <p className={gameState.currentRound >= 3 ? '' : 'inactive'}>{__('sim_ronde')} 3</p>
            <p className={gameState.currentRound >= 4 ? '' : 'inactive'}>{__('sim_ronde')} 4</p>
            <span className={gameState.currentRound > 4 ? '' : 'inactive'}><img alt={'finish'} src={Finish}/></span>
          </div>

          <div className={'warning-container ' + (this.state.showWarning ? ' show' : '')}>
            <div onClick={this.warningPopup.bind(this)} className="close-button">
              <span className="close-icon">
                <img src={CloseIcon} height='15' alt=''/>
              </span>
            </div>
            <img alt="disaster" src={Warning}/>
            <div className={'content'}>
              {__('sim_ministerie_overfinancierd_melding')}
            </div>
          </div>
        </div>
      </div>
    )
  }
}


export default connect(({gameState, gameStateInput}) => ({gameState, gameStateInput}))(FeedbackStatusRounds);



// WEBPACK FOOTER //
// ./src/components/elements/feedback/FeedbackStatusRounds.js